import styled from "styled-components";
import Block, { BlockContent, BlockGrid } from "~/components/Block";
import { getCommonSliceProps, getRichText } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";
import { paragraph } from "~/styles/mixins";
import { smallerThan } from "~/styles/theme";

const BlockContentWrapper = styled(BlockContent)`
  color: ${(p) => p.color || p.theme.colors.dark};
  width: ${(p) => (p.forceFullWidth ? "100%" : "50%")};
  ${smallerThan("500px")} {
    width: 100%;
  }
  p {
    ${paragraph};
    /* margin: ${(p) => p.theme.sizes.vSpacing}rem 0; */
    padding: ${(p) => p.theme.sizes.vSpacing}rem 0;
    max-width: ${(p) => p.maxWidth || "none"};
  }
  a {
    color: ${(p) => p.color || p.theme.colors.dark};
  }
`;

const RichTextWrapper = styled.div`
  display: flex;
  /* align-items: flex-end; */
  align-items: ${(p) => p.alignItems || "flex-start"};

  img {
    display: block;
    width: 100%;
  }
`;

function RichTextSlice(props) {
  let {
    spacingTop = 0,
    spacingBottom = 6,

    backgroundColor,
    color,
    highlightColor,

    text,
    textColumns = [], // overwrites text
    forceFullWidth = false,
  } = props;

  if (textColumns.length > 0) forceFullWidth = true;

  // console.log('textColumns', textColumns);

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContentWrapper forceFullWidth={forceFullWidth} color={color}>
        {textColumns.length > 0 ? (
          <BlockGrid cols={textColumns.length} columnsOnMobile={1}>
            {textColumns.map(
              ({ textAlign = "left", alignItems = "flex-star", text }, i) => (
                <RichTextWrapper key={i} style={{ textAlign }} alignItems={alignItems}>
                  {text}
                </RichTextWrapper>
              )
            )}
          </BlockGrid>
        ) : (
          text
        )}
      </BlockContentWrapper>
    </Block>
  );
}

export function mapSliceToProps(slice) {
  const { primary, items = [] } = slice;

  // console.log('mapSliceToProps', slice);

  const resolveAlignItems = {
    top: "flex-start",
    center: "center",
    bottom: "flex-end",
  };

  // check if textColumns is empty??
  // a new RichText slice will automaticly have items
  let textColumns = items.map((item) => ({
    textAlign: item.text_align ? item.text_align.toLowerCase() : "left",
    alignItems: item.vertical_align
      ? resolveAlignItems[item.vertical_align.toLowerCase()]
      : "left",
    text: getRichText(item.text_col),
  }));
  // textColumns = textColumns.filter(t => t !== null);

  // CHECK IF TEXT COLUMNS IS ONLT 1, AND .text_col.length === 0 IS EMPTY

  if (items.length === 1) {
    if (items[0].text_col) {
      if (items[0].text_col.length === 0) {
        textColumns = [];
      }
      if (items[0].text_col === null) {
        textColumns = [];
      }
    }
  }

  // console.log('textColumns', textColumns);

  const props = {
    ...getCommonSliceProps(slice),

    text: getRichText(primary.text),
    textColumns, // items.map(item => getRichText(item.text_col)),
    forceFullWidth: primary.force_full_width === "Yes",
  };

  return props;
}

export default connectSlice(mapSliceToProps)(RichTextSlice);
